import Immutable from 'seamless-immutable';
import _ from 'lodash';
import EmailIntegrationModel from './email-integrations-model';

function create(integrations = []) {
  return Immutable(_.map(integrations, EmailIntegrationModel.create));
}

function deserialize(integrations = []) {
  return Immutable(_.map(integrations, EmailIntegrationModel.deserialize));
}

export default {
  create,
  deserialize,
};
